import React, { Component } from 'react';
import { translate } from '../Services/translation';
import { connect } from 'react-redux';
import { setResetPasswordEmail, showBahagConfirmSentEmail, showBahagSignIn, forgotPassword } from '../actions/Bahag.action';

class BahagForgetPassword extends Component {
    constructor(props) {
        super(props);

        this.state = {
            forgetPasswordEmail: ""
        };

        this.handleResetPasswordSubmit = this.handleResetPasswordSubmit.bind(this);
        this.handleForgetPasswordEmail = this.handleForgetPasswordEmail.bind(this);
    }
    //Forget password rendering and Logic
    renderForgetPassword() {
        return (
            <>
                <h3 id="bahag-signin" className="checkout__section-title">{translate('checkout.bahag.signin.header')}</h3>
                <div className="germany-section__forget-container">
                    <span></span>
                    <p className="germany-section__forget-container--header">{translate("checkout.bahag.forget.password.header")}</p>
                    <p className="germany-section__forget-container--subheader">{translate("checkout.bahag.forget.password.description")}</p>
                    <form onSubmit={this.handleResetPasswordSubmit}>
                        <div className="germany-section__forget-poassword">
                            <div className="germany-section__forget-poassword--input-container">
                                <input type="email" placeholder={translate('checkout.bahag.forget.password.placeholder.email')} required onChange={this.handleForgetPasswordEmail} name="forgetPasswordEmail"></input>
                            </div>
                            <div className="germany-section__forget-poassword--buttons">
                                <button
                                    className="germany-section__forget-poassword--buttons--signin" type="submit">{translate('checkout.bahag.reset.password.button')}
                                </button>
                                <a onClick={() => this.props.showBahagSignIn()}>{translate('checkout.bahag.back.to.signin')}</a>
                            </div>
                        </div>
                    </form>
                </div>
            </>
        )
    }

    handleForgetPasswordEmail(event) {
        const { value } = event.target;

        this.setState({
            forgetPasswordEmail: value
        });

    }

    async handleResetPasswordSubmit(event) {
        event.preventDefault();
        const email = this.state.forgetPasswordEmail
        if (email) {
            const responseForgetPassword = await this.props.forgotPassword(email);
            if (responseForgetPassword) {
                const responseForgetPasswordCode = responseForgetPassword.Data
                if (responseForgetPasswordCode === 200) {
                    const resetPasswordEmail = this.state.forgetPasswordEmail;
                    if (resetPasswordEmail) {
                        await this.props.setResetPasswordEmail(resetPasswordEmail);
                    }
                    await this.props.showBahagConfirmSentEmail();
                }
            }
        }
    }

    render() {
        return (
            <div>
                {this.renderForgetPassword()}
            </div>
        );
    }
}

const mapDispatchToProps = (dispatch) => ({
    showBahagSignIn: () => dispatch(showBahagSignIn(true)),
    showBahagConfirmSentEmail: () => dispatch(showBahagConfirmSentEmail(true)),
    forgotPassword: (email) => dispatch(forgotPassword(email)),
    setResetPasswordEmail: (resetPasswordEmail) => dispatch(setResetPasswordEmail(resetPasswordEmail))
});

export default connect(null, mapDispatchToProps)(BahagForgetPassword);
